import { isToggleEnabled } from '../api/toggles/togglesApi';

export interface UrlToggle {
  url: string;
  toggle: string;
  isLegacy?: boolean;
  isExternal?: boolean;
  isShownInHeader?: boolean;
}

export interface conditionToggle {
  condition: boolean;
  toggle?: string;
}

export interface Route {
  text: string;
  url: string;
  urlToggle?: UrlToggle;
  condition?: conditionToggle;
  isLegacy?: boolean;
  isExternal?: boolean;
  allowRoles?: string[];
  denyRoles?: string[];
}

export interface RouteGroup {
  isUserDropdown?: boolean;
  groupName: string;
  routes: Route[];
}

export interface RouteConfig {
  groups: RouteGroup[];
}

export const applyCondition = (conditonToggle: conditionToggle): boolean => {
  if (conditonToggle.toggle && !isToggleEnabled(conditonToggle.toggle)) {
    return !conditonToggle.condition;
  }

  return conditonToggle.condition;
};

export const applyToggles = (route: Route, legacyUrl: string) => {
  if (route?.urlToggle && isToggleEnabled(route.urlToggle.toggle)) {
    route.isLegacy = route.urlToggle.isLegacy || false;
    route.isExternal = route.urlToggle.isLegacy || false;
    route.url = route.urlToggle.url;
  } else if (route.isLegacy) {
    route.url = `${legacyUrl + route.url}`;
  }
};

export const filterRouteConfig = (roles: string[], routeConfig: RouteConfig, legacyUrl: string) => {
  return {
    groups: routeConfig.groups
      .map((group) => {
        return {
          ...group,
          routes: group.routes
            .filter((route) => (route.condition ? applyCondition(route.condition) : true))
            .filter((route) => {
              if (route.denyRoles) {
                if (route.denyRoles.some((deny) => roles.includes(deny))) return false;
              }

              if (route.allowRoles) {
                return route.allowRoles.some((allow) => roles.includes(allow));
              }

              return false;
            })
            .map((route) => {
              applyToggles(route, legacyUrl);
              return {
                ...route,
                isExternal: route.isExternal || false,
              };
            }),
        };
      })
      .filter((group) => group.routes.length > 0),
  };
};
